<footer class="footer ">
  <div class="container">
    <nav class="pull-left">
      <ul>
        <li>
        </li>
        <li>
        </li>
      </ul>
    </nav>
  </div>
</footer>
